import * as React from 'react';
import * as _ from 'lodash';
import { Carousel, Image } from 'antd';

export interface SlideshowProps {
    images: string[];
}

export function Slideshow(props: SlideshowProps) {

    var images = _.map(props.images, (image: string, index) => <div key={index}><Image src={image} preview={false} /></div>);

    return (
        <Image.PreviewGroup>
            <Carousel effect="fade" autoplay autoplaySpeed={3000} pauseOnHover>
                {images}
            </Carousel>
        </Image.PreviewGroup>
    );
}

export default Slideshow;